module.exports = __webpack_public_path__ + "img/img_32389_0_483.ae532da7.png";